import React from 'react';
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';

const PercentageMask = ({ inputRef, onChange, ...other }) => {
  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: other.name,
            value: Number(values.value) || 0
          }
        });
      }}
      allowLeadingZeros
      thousandSeparator
      suffix=" %"
    />
  );
};

export default PercentageMask;

PercentageMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
